module.exports = __webpack_public_path__ + "4474af7025cea9bbbb49fe555a2005ab.jpg";